import thTH from './th_TH'

export default {
  tagsView: {
    refresh: 'รีเฟรช',
    close: 'ปิด',
    closeOthers: 'ปิดอื่นๆ',
    closeAll: 'ปิดทั้งหมด'
  },
  ...thTH,
  ETD: 'ETD',
  ETA: 'ETA',
  i18nDemo: {
    message: 'นี่คือข้อความแจ้งเตือนภาษาจีน',
    btnDesc: 'ปุ่มภาษาจีน',
    messageBtn: 'คลิกเพื่อดูข้อความ'
  },
  baseInfo: {
    seaport: {
      tabPort: {
        tabName: 'ท่าเรือ'
      },
      tabEdiPort: {
        tabName: 'ท่าเรือ EDI',
        shipCompany: 'บริษัทเรือ',
        originPortCode: 'รหัสท่าเรือเดิม',
        currentPortCode: 'รหัสท่าเรือปัจจุบัน',
        shipCompanyCheck: 'กรุณาเลือกบริษัทเรือ!',
        originPortCodeCheck: 'กรุณาเลือกท่าเรือ!',
        currentPortCodeCheck: 'กรุณาใส่รหัสท่าเรือ 5 หลัก!'
      },
      tabAmsPort: {
        tabName: 'ท่าเรือ AMS',
        amsPortMaintain: 'บำรุงรักษาท่าเรือ AMS',
        usNo: 'US NO',
        englishName: 'ชื่อภาษาอังกฤษ',
        unNo: 'UN NO',
        country: 'ประเทศ',
        remark: 'หมายเหตุ',
        usNoCheck: 'กรุณากรอก US NO. ที่ถูกต้อง',
        englishNameCheck: 'ชื่อภาษาอังกฤษไม่สามารถเว้นว่างได้',
        unNoCheck: 'กรุณากรอก UN NO. ที่ถูกต้อง',
        countryCheck: 'ประเทศไม่สามารถเว้นว่างได้'
      }
    },
    city: {
      code: 'รหัส',
      chineseName: 'ชื่อภาษาจีน',
      englishName: 'ชื่อภาษาอังกฤษ',
      locationCode: 'รหัสเมือง',
      country: 'ประเทศ',
      addBaseCity: 'เพิ่มเมืองพื้นฐาน',
      codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
      englishNameCheck: 'ชื่อภาษาอังกฤษไม่สามารถเว้นว่างได้!',
      countryCheck: 'กรุณาเลือกประเทศ!',
      lon: 'ลองจิจูด',
      lat: 'ละติจูด'
    },
    overseaWarehouse: {
      warehouseCode: 'รหัสคลังสินค้า',
      countryChineseName: 'ชื่อภาษาจีน',
      countryEnglishName: 'ชื่อภาษาอังกฤษ',
      country: 'ประเทศ',
      province: 'รัฐ',
      city: 'เมือง',
      zipCode: 'รหัสไปรษณีย์',
      address: 'ที่อยู่โดยละเอียด',
      address1: 'ที่อยู่ 1',
      address2: 'ที่อยู่ 2',
      address3: 'ที่อยู่ 3',
      ifFba: 'เป็นคลัง Amazon หรือไม่',
      entryRequirements: 'ข้อกำหนดการเข้าคลัง',
      warehouseAgeCalculationRules: 'กฎการคำนวณอายุสินค้าคงคลัง',
      warehouseAgeCalculationRulesEdit: 'กฎการคำนวณอายุสินค้าคงคลัง (สัปดาห์)',
      btn: {
        newFbaWarehouse: 'เพิ่มคลัง Amazon',
        newOverseaWarehouse: 'เพิ่มคลังสินค้าต่างประเทศ'
      },
      msg: {
        warehouseNoEmpty: 'รหัสคลังสินค้าห้ามว่างเปล่า',
        countryNoEmpty: 'ประเทศห้ามว่างเปล่า',
        cityNoEmpty: 'เมืองห้ามว่างเปล่า',
        zipCodeNoEmpty: 'รหัสไปรษณีย์ห้ามว่างเปล่า',
        addressNoEmpty: 'ที่อยู่ละเอียดห้ามว่างเปล่า',
        chineseNameNoEmpty: 'ชื่อภาษาจีนห้ามว่างเปล่า',
        englishNameNoEmpty: 'ชื่อภาษาจีนห้ามว่างเปล่า',
        warehouseAgeCalculationRulesNoEmpty: 'กฎการคำนวณอายุคลังสินค้าห้ามว่างเปล่า',
        unSelectFbaWarehouse: 'ยังไม่ได้เลือกคลัง FBA',
        canNotEditFbaWarehouse: 'ไม่สามารถแก้ไขคลัง Amazon',
        duplicateAddition: '{0} ได้ถูกเพิ่มแล้ว ไม่สามารถเพิ่มซ้ำ',
        warehouseNoLen: 'ความยาวรหัสคลังสินค้าต่างประเทศต้องไม่เกิน 16 หลัก'
      }
    },
    basicData: {
      continent: {
        code: 'รหัส',
        name: 'ชื่อ',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        nameCheck: 'ชื่อห้ามว่างเปล่า!'
      },
      region: {
        code: 'รหัส',
        name: 'ชื่อภาษาจีน',
        nameEnglish: 'ชื่อภาษาอังกฤษ',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        nameCheck: 'ชื่อภาษาจีนห้ามว่างเปล่า!'
      },
      mscService: {
        serviceCode: 'รหัสบริการ',
        serviceName: 'ชื่อบริการ',
        serviceCodeCheck: 'รหัสบริการห้ามว่างเปล่า!',
        serviceNameCheck: 'ชื่อบริการห้ามว่างเปล่า!'
      },
      network: {
        code: 'รหัสเครือข่าย',
        name: 'ชื่อเครือข่าย',
        codeCheck: 'รหัสเครือข่ายห้ามว่างเปล่า!',
        nameCheck: 'ชื่อเครือข่ายห้ามว่างเปล่า!'
      },
      currency: {
        serialNumber: 'ลำดับ',
        code: 'รหัส',
        name: 'ชื่อ',
        localName: 'ชื่อท้องถิ่น',
        interchangeCode: 'รหัสแลกเปลี่ยน',
        isoCode: 'รหัส ISO',
        defaultFractionDigits: 'ทศนิยมสกุลเงิน',
        symbol: 'สัญลักษณ์',
        remarks: 'หมายเหตุ',
        addBaseCurrency: 'เพิ่มสกุลเงินพื้นฐาน',
        serialNumberCheck: 'ลำดับห้ามว่างเปล่า!',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        nameCheck: 'ชื่อห้ามว่างเปล่า!',
        interchangeCodeCheck: 'รหัสแลกเปลี่ยนห้ามว่างเปล่า!',
        isoCodeCheck: 'รหัส ISO ห้ามว่างเปล่า!',
        defaultFractionDigitsCheck: 'ทศนิยมสกุลเงินห้ามว่างเปล่า!',
        carryRule: 'กฎการปัดเศษสกุลเงิน',
        rounding: 'ปัดเศษ',
        truncation: 'ตัดทอน'
      },
      eqType: {
        code: 'รหัส',
        name: 'ชื่อ',
        localName: 'ชื่อท้องถิ่น',
        remark: 'หมายเหตุ',
        addBaseEQType: 'เพิ่มประเภทกล่องพื้นฐาน',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!'
      },
      packing: {
        serialNumber: 'ลำดับ',
        code: 'รหัส',
        name: 'ชื่อ',
        englishName: 'ชื่อภาษาอังกฤษ',
        chineseName: 'ชื่อภาษาจีน',
        interchangeCode: 'รหัสแลกเปลี่ยน',
        isoCode: 'รหัส ISO',
        position: 'ตำแหน่ง',
        ediCode: 'รหัส EDI',
        addBasePacking: 'เพิ่มบรรจุภัณฑ์พื้นฐาน',
        serialNumberCheck: 'ลำดับห้ามว่างเปล่า!',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        interchangeCodeCheck: 'รหัสแลกเปลี่ยนห้ามว่างเปล่า!',
        isoCodeCheck: 'รหัส ISO ห้ามว่างเปล่า!',
        positionCheck: 'ตำแหน่งไม่สามารถเว้นว่างได้!',
        userDefinedField: 'ฟิลด์กำหนดเอง'
      },
      orderFormType: {
        code: 'รหัส',
        name: 'ชื่อ',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        nameCheck: 'ชื่อห้ามว่างเปล่า!'
      },
      cargoType: {
        code: 'รหัส',
        chineseName: 'ชื่อภาษาจีน',
        englishName: 'ชื่อภาษาอังกฤษ',
        sea: 'ใช้งานทางทะเล',
        air: 'ใช้งานทางอากาศ',
        fbaSea: 'ใช้งาน FBA ทางทะเล',
        fbaAir: 'ใช้งาน FBA ทางอากาศ',
        fbaRailway: 'ใช้งาน FBA ทางรถไฟ',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        chineseNameCheck: 'ชื่อภาษาจีนไม่สามารถเว้นว่างได้!'
      },
      incoTerm: {
        serialNumber: 'ลำดับ',
        code: 'รหัส',
        name: 'ชื่อ',
        localName: 'ชื่อท้องถิ่น',
        interchangeCode: 'รหัสแลกเปลี่ยน',
        isoCode: 'รหัส ISO',
        remark: 'หมายเหตุ',
        addBaseIncoTerm: 'เพิ่มข้อกำหนดทางการค้าพื้นฐาน',
        serialNumberCheck: 'ลำดับห้ามว่างเปล่า!',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        nameCheck: 'ชื่อห้ามว่างเปล่า!',
        interchangeCodeCheck: 'รหัสแลกเปลี่ยนห้ามว่างเปล่า!',
        isoCodeCheck: 'รหัส ISO ไม่สามารถเว้นว่างได้!'
      },
      shippingTerm: {
        serialNumber: 'ลำดับ',
        code: 'รหัส',
        name: 'ชื่อ',
        localName: 'ชื่อท้องถิ่น',
        interchangeCode: 'รหัสแลกเปลี่ยน',
        isoCode: 'รหัส ISO',
        remark: 'หมายเหตุ',
        addBaseShippingTerm: 'เพิ่มข้อกำหนดการขนส่งพื้นฐาน',
        serialNumberCheck: 'ลำดับห้ามว่างเปล่า!',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        nameCheck: 'ชื่อห้ามว่างเปล่า!',
        interchangeCodeCheck: 'รหัสแลกเปลี่ยนห้ามว่างเปล่า!',
        isoCodeCheck: 'รหัส ISO ไม่สามารถเว้นว่างได้!',
        defaultContainerLoadType: 'แสดงประเภทการรวมสินค้าโดยปริยาย',
        defaultShow: 'แสดงโดยปริยาย',
        operationTypeTip: '※หลังจากตั้งค่าแล้ว จะเพิ่มช่องข้อกำหนดการขนส่งของใบตราส่งหลัก/ใบตราส่งย่อยสำหรับธุรกิจนำเข้า-ส่งออกทางทะเลที่ตรงกับประเภทการรวมสินค้า โดยจะแสดงข้อกำหนดการขนส่งนั้นโดยปริยาย'
      },
      paymentTerm: {
        serialNumber: 'ลำดับ',
        code: 'รหัส',
        name: 'ชื่อ',
        localName: 'ชื่อท้องถิ่น',
        interchangeCode: 'รหัสแลกเปลี่ยน',
        isoCode: 'รหัส ISO',
        remark: 'หมายเหตุ',
        addBasePaymentTerm: 'เพิ่มข้อกำหนดค่าขนส่งพื้นฐาน',
        serialNumberCheck: 'ลำดับห้ามว่างเปล่า!',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        nameCheck: 'ชื่อห้ามว่างเปล่า!',
        interchangeCodeCheck: 'รหัสแลกเปลี่ยนห้ามว่างเปล่า!',
        isoCodeCheck: 'รหัส ISO ไม่สามารถเว้นว่างได้!'
      },
      tradeTerm: {
        serialNumber: 'ลำดับ',
        code: 'รหัส',
        name: 'ชื่อภาษาจีน',
        localName: 'ชื่อท้องถิ่น',
        englishName: 'ชื่อภาษาอังกฤษ',
        interchangeCode: 'รหัสแลกเปลี่ยน',
        isoCode: 'รหัส ISO',
        remark: 'หมายเหตุ',
        addBaseTradeTerm: 'เพิ่มวิธีการค้าพื้นฐาน',
        serialNumberCheck: 'ลำดับห้ามว่างเปล่า!',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        nameCheck: 'ชื่อห้ามว่างเปล่า!',
        interchangeCodeCheck: 'รหัสแลกเปลี่ยนห้ามว่างเปล่า!',
        isoCodeCheck: 'รหัส ISO ไม่สามารถเว้นว่างได้!'
      },
      priceAirService: {
        code: 'รหัส',
        chineseName: 'ชื่อภาษาจีน',
        englishName: 'ชื่อภาษาอังกฤษ',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        chineseNameCheck: 'ชื่อภาษาจีนไม่สามารถเว้นว่างได้!'
      },
      portGroup: {
        portCode: 'รหัสท่าเรือ',
        groupCode: 'กลุ่มท่าเรือ',
        portCodeCheck: 'รหัสท่าเรือไม่สามารถเว้นว่างได้!',
        groupCodeCheck: 'กลุ่มท่าเรือไม่สามารถเว้นว่างได้!'
      },
      otherChargeItem: {
        chargeItemCode: 'รหัส',
        chineseName: 'ชื่อภาษาจีน',
        measure: 'วิธีการคิดเงิน',
        defaultApPrice: 'ราคาต่อหน่วยที่ควรได้รับโดยค่าเริ่มต้น',
        remark: 'หมายเหตุ',
        chargeWeight: 'คำนวณตามน้ำหนักคิดเงิน',
        wt: 'คำนวณตามน้ำหนักรวม',
        job: 'คำนวณตามจำนวนตั๋ว',
        chargeItemCodeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        chineseNameCheck: 'ชื่อภาษาจีนไม่สามารถเว้นว่างได้!'
      },
      customerType: {
        typeId: 'ระดับ',
        chineseName: 'ชื่อภาษาจีน',
        englishName: 'ชื่อภาษาอังกฤษ',
        typeIdCheck: 'ระดับไม่สามารถเว้นว่างได้!',
        chineseNameCheck: 'ชื่อภาษาจีนไม่สามารถเว้นว่างได้!',
        englishNameCheck: 'ชื่อภาษาอังกฤษไม่สามารถเว้นว่างได้!'
      },
      appraisalCategory: {
        serialNumber: 'ลำดับ',
        serialNumberCheck: 'ลำดับที่ไม่สามารถเว้นว่างได้',
        code: 'รหัส',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้',
        chineseName: 'ชื่อภาษาจีน',
        englishName: 'ชื่อภาษาอังกฤษ',
        chineseNameCheck: 'ชื่อภาษาจีนไม่สามารถเว้นว่างได้!',
        englishNameCheck: 'ชื่อภาษาอังกฤษไม่สามารถเว้นว่างได้!'
      },
      blMode: {
        serialNumber: 'ลำดับ',
        code: 'รหัส',
        name: 'ชื่อ',
        localName: 'ชื่อท้องถิ่น',
        interchangeCode: 'รหัสแลกเปลี่ยน',
        isoCode: 'รหัส ISO',
        blType: 'ประเภทใบตราส่งสินค้า',
        remark: 'หมายเหตุ',
        addBaseBlMode: 'วิธีการเพิ่มใบตราส่งสินค้า',
        serialNumberCheck: 'ลำดับห้ามว่างเปล่า!',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        nameCheck: 'ชื่อห้ามว่างเปล่า!',
        interchangeCodeCheck: 'รหัสแลกเปลี่ยนห้ามว่างเปล่า!',
        isoCodeCheck: 'รหัส ISO ไม่สามารถเว้นว่างได้!'
      },
      cutomJobType: {
        serialNumber: 'ลำดับ',
        code: 'รหัส',
        name: 'ชื่อ',
        localName: 'ชื่อท้องถิ่น',
        englishName: 'ชื่อภาษาอังกฤษ',
        type: 'ประเภทธุรกิจ',
        remarks: 'หมายเหตุ',
        containerLoadType: 'รูปแบบธุรกิจ',
        addBaseBlMode: 'เพิ่มวิธีการค้าพื้นฐาน',
        serialNumberCheck: 'ลำดับห้ามว่างเปล่า!',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        nameCheck: 'ชื่อห้ามว่างเปล่า!',
        englishNameCheck: 'ชื่อภาษาอังกฤษไม่สามารถเว้นว่างได้!',
        typeCheck: 'ประเภทธุรกิจต้องไม่ว่างเปล่า!',
        interchangeCode: 'รหัสแลกเปลี่ยน',
        codeTips1: '*รูปแบบรหัส: ภาษาอังกฤษและตัวเลข จำกัดที่ 4 ตัวอักษร',
        codeTips2: 'ความยาวรหัสเกินกำหนด กรุณากรอกใหม่!',
        codeTips3: 'รูปแบบรหัสไม่ถูกต้อง กรุณากรอกใหม่!',
        codeTips4: '*รูปแบบรหัส: ภาษาอังกฤษ ตัวเลข และผสมกัน จำกัดที่ 10 ตัวอักษร'
      },
      chargeUnit: {
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        chineseNameCheck: 'ชื่อภาษาจีนไม่สามารถเว้นว่างได้!',
        englishNameCheck: 'ชื่อภาษาอังกฤษไม่สามารถเว้นว่างได้!',
        chargeUnitAndUnitCheck: 'กรุณาเลือกอย่างน้อยหนึ่งหน่วยในการเรียกเก็บเงินหรือหน่วยแสดงผล',
        seaFreightAndAirFreightCheck: 'กรุณาเลือกอย่างน้อยหนึ่งระหว่างการขนส่งทางทะเลหรือทางอากาศ',
        businessTypeCheck: 'กรุณาเลือกอย่างน้อยหนึ่งระหว่างการขนส่งทางทะเล ทางอากาศ FBAทางทะเล FBAทางอากาศ หรือ FBAทางรถไฟ',
        fbaSeaAndAirAndRailwayCheck: 'กรุณาเลือกอย่างน้อยหนึ่งระหว่างการขนส่งทางทะเล ทางอากาศ หรือทางรถไฟ'
      },
      dangerousGoods: {
        codeCheck: 'กรุณากรอกเลขที่สหประชาชาติ'
      },
      cargoInformation: {
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        chineseNameCheck: 'ชื่อภาษาจีนไม่สามารถเว้นว่างได้!',
        englishNameCheck: 'ชื่อภาษาอังกฤษไม่สามารถเว้นว่างได้!'
      },
      propulsionType: {
        codeCheck: 'ชื่อห้ามว่างเปล่า!'
      },
      baseCustomsDeclarationType: {
        code: 'รหัส',
        name: 'ชื่อภาษาจีน',
        englishName: 'ชื่อภาษาอังกฤษ',
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        nameCheck: 'ชื่อภาษาจีนห้ามว่างเปล่า!',
        englishNameCheck: 'ชื่อภาษาอังกฤษไม่สามารถเว้นว่างได้!',
        codeTooLong: 'คอลัมน์【รหัส】ข้อมูลยาวเกินไป',
        nameTooLong: 'คอลัมน์【ชื่อภาษาจีน】ข้อมูลยาวเกินไป',
        englishNameTooLong: 'คอลัมน์【ชื่อภาษาอังกฤษ】ข้อมูลยาวเกินไป',
        addBaseCustomsDeclarationType: 'เพิ่มประเภทการสำแดงสินค้า',
        isPlatform: 'เป็นข้อมูลจากแพลตฟอร์มหรือไม่',
        PlatformTip: 'ข้อมูลที่เพิ่มจากแพลตฟอร์มไม่สามารถแก้ไขได้!'
      },
      gpExplainTitle: {
        codeCheck: 'รหัสไม่สามารถเว้นว่างได้!',
        chineseNameCheck: 'ชื่อภาษาจีนไม่สามารถเว้นว่างได้!',
        englishNameCheck: 'ชื่อภาษาอังกฤษไม่สามารถเว้นว่างได้!'
      }
    },
    airport: {
      addBasePort: 'เพิ่มท่าเรือพื้นฐาน',
      serialNumber: 'ลำดับ',
      code: 'รหัส',
      chineseName: 'ชื่อภาษาจีน',
      englishName: 'ชื่อภาษาอังกฤษ',
      interchangeCode: 'รหัสแลกเปลี่ยน',
      isoCode: 'รหัส ISO',
      countryCode: 'ประเทศ',
      region: 'ภูมิภาค',
      requirement: 'ข้อกำหนดท่าเรือ',
      whetherToAdd: 'เพิ่มแล้วหรือไม่',
      portAdd: 'เพิ่มท่าเรือ',
      portEdit: 'แก้ไขท่าเรือ',
      cityName: 'ชื่อเมือง',
      cityCode: 'รหัสเมือง',
      codeCheck: 'กรุณากรอกรหัสท่าเรือที่ถูกต้อง',
      interchangeCodeCheck: 'รหัสแลกเปลี่ยนไม่สามารถเว้นว่างได้',
      isoCodeCheck: 'รหัส ISO ไม่สามารถเว้นว่างได้',
      englishNameCheck: 'ชื่อภาษาอังกฤษไม่สามารถเว้นว่างได้'
    },
    operation: {
      operationType: 'ประเภทความต้องการในการดำเนินการ',
      lobType: 'ประเภทธุรกิจ',
      code: 'รหัส',
      lob: 'ประเภทธุรกิจ',
      operationRequirementType: 'ประเภทการดำเนินการ',
      contentDescription: 'รหัส/คำอธิบายเนื้อหา',
      operationMaintain: 'การบำรุงรักษาความต้องการในการดำเนินการ',
      remark: 'หมายเหตุ',
      enterContentDescription: 'กรุณากรอกรหัสหรือคำอธิบายเนื้อหา'
    },
    customsCommodityCode: {
      code: 'รหัสสินค้า',
      commodityName: 'ชื่อสินค้า',
      mfnRate: 'อัตราภาษีชาติที่ได้รับสิทธิประโยชน์สูงสุด',
      generalRate: 'อัตราภาษีทั่วไป',
      vat: 'ภาษีมูลค่าเพิ่ม',
      legalUnit: 'หน่วยตามกฎหมาย',
      mscCommodity: 'ชื่อสินค้าภาษาอังกฤษ (MSC)',
      secondUnit: 'หน่วยที่สอง',
      superviseMode: 'วิธีการกำกับดูแล',
      customsCommodityCodeMaintain: 'การบำรุงรักษารหัสสินค้าศุลกากร',
      countryCode: 'รหัสประเทศ',
      countryCodeCheck: '国家代码不能为空. ',
      codeCheck: '商品编码不能为空. ',
      commodityNameCheck: 'ชื่อสินค้าไม่สามารถเว้นว่างได้'
    },
    usCommodityCode: {
      systemCode: 'รหัสระบบ',
      tradeName: 'ชื่อสินค้า',
      productDescription: 'คำอธิบายสินค้า',
      descriptionCode: 'รหัสคำอธิบาย',
      customsTariff: 'อัตราภาษีศุลกากร',
      additionalTaxRate056: 'อัตราภาษีเพิ่มเติม 056',
      including499AdditionalTaxRate: 'อัตราภาษีเพิ่มเติมรวม 499',
      including501AdditionalTaxRate: 'อัตราภาษีเพิ่มเติมรวม 501',
      chinaAdditionalTaxRate: 'อัตราภาษีเพิ่มเติมจีน',
      chinaSurtaxTariff: 'กฎอัตราภาษีเพิ่มเติมจีน',
      chinaSurtaxClause: 'ข้อกำหนดภาษีเพิ่มเติมจีน',
      enable: 'เปิดใช้งาน',
      disable: 'ปิดใช้งาน',
      chinaHongKongSurtaxTariff: 'กฎอัตราภาษีเพิ่มเติมฮ่องกงจีน',
      remark: 'หมายเหตุ'
    },
    country: {
      serialNumber: 'ลำดับ',
      code: 'รหัส',
      englishName: 'ชื่อภาษาอังกฤษ',
      chineseName: 'ชื่อภาษาจีน',
      continent: 'ทวีป',
      interchangeCode: 'รหัสแลกเปลี่ยน',
      isoCode: 'รหัส ISO',
      countryMaintain: 'การบำรุงรักษาประเทศ'
    },
    rateManagement: {
      copyRate: 'คัดลอกอัตราแลกเปลี่ยน',
      originalCurrency: 'สกุลเงินต้นทาง',
      benchmarkCurrency: 'สกุลเงินอ้างอิง',
      rate: 'อัตราแลกเปลี่ยน',
      effectiveMonth: 'เดือนที่มีผลบังคับใช้',
      currentMonth: 'เดือนปัจจุบัน',
      baseCuurency: 'สกุลเงินอ้างอิง',
      currency: 'สกุลเงินต้นทาง',
      month: 'เดือนที่มีผลบังคับใช้',
      rateMaintain: 'การบำรุงรักษาอัตราแลกเปลี่ยน',
      currencyCheck: 'กรุณากรอกสกุลเงินต้นทาง!',
      rateCheck: 'กรุณากรอกอัตราแลกเปลี่ยน!',
      rateIsTooLong: 'อัตราแลกเปลี่ยนสูงเกินไป กรุณาแก้ไข',
      repeatCheck: 'พบการตั้งค่าซ้ำ กรุณาแก้ไข!',
      repeatCheck2: 'พบการตั้งค่าซ้ำสำหรับอัตราแลกเปลี่ยน {0} เป็น {1} กรุณาแก้ไข!',
      copyRateMaintain: 'คัดลอกอัตราแลกเปลี่ยนของเดือนที่กำหนด',
      copyCurrentMonthCheck: 'ไม่สามารถคัดลอกข้อมูลเดือนปัจจุบันได้ กรุณาเลือกเดือนอื่น!',
      copyRowDataCheck: 'ไม่มีข้อมูลของเดือนนี้!',
      copyRateSuccess: 'คัดลอกอัตราแลกเปลี่ยนสำเร็จ',
      notFoundRate: 'ไม่พบอัตราแลกเปลี่ยนสำหรับสกุลเงิน {0} กรุณาบำรุงรักษาอัตราแลกเปลี่ยนที่เกี่ยวข้อง!',
      setRateCacheRange: 'ตั้งค่าช่วงเวลาการแคชอัตราแลกเปลี่ยน',
      setRateCacheRangeNote: 'ตั้งค่าช่วงเดือนของการแคชอัตราแลกเปลี่ยนไว้ที่ 18-36 เดือน',
      setRateCacheRangePrefix: 'เดือนที่แคช',
      setRateCacheRangeSuffix: 'เดือน'
    },
    // 合作伙伴
    partner: {
      companyName: 'พันธมิตร',
      companyType: 'ประเภทลูกค้า',
      customerTypeId: 'ระดับลูกค้า',
      remarks: 'คำอธิบายเพิ่มเติม',
      approvedState: 'สถานะการตรวจสอบ',
      volume: 'จำนวน票',
      cmpIdx: 'เลขที่',
      shortName: 'ชื่อย่อ',
      cnShortName: 'รหัส',
      region: 'ประเทศ',
      area: 'ภูมิภาค',
      chineseName: 'ชื่อภาษาจีน',
      englishName: 'ชื่อภาษาอังกฤษ',
      contractStatus: 'สถานะการเซ็นสัญญา',
      branchId: 'สาขาที่เกี่ยวข้อง',
      approvedBy: 'ผู้ตรวจสอบ',
      dateApproved: 'วันที่ตรวจสอบ',
      createBy: 'ผู้สร้าง',
      dateType: 'ประเภทวันที่',
      controlSetting: 'ประเภทวันที่ตั้งค่าการควบคุมเครดิต',
      creditDateType: 'วิธีการชำระเงิน',
      blacklist: 'บัญชีดำ',
      cargoSource: 'ประเภทการรับสินค้า',
      receivableDeposit: 'ประเภทรายรับรายจ่าย',
      accountingPeriod: 'ระยะเวลาบัญชี',
      quota: 'วงเงิน',
      creditQuota: 'วงเงินควบคุมเครดิต',
      creditCurrency: 'สกุลเงินควบคุมเครดิต',
      payment: 'การชำระเงิน',
      supplierDirector: 'ผู้รับผิดชอบผู้จัดหา',
      dateCreated: 'วันที่สร้าง',
      modifiedBy: 'ผู้แก้ไข',
      dateModified: 'วันที่แก้ไข',
      isActive: 'มีผลหรือไม่',
      relateTenantUuid: 'ลูกค้าอีคอมเมิร์ซ',
      sales: 'การขาย',
      freightVolume30: '30 วัน (ตั๋ว)',
      freightVolume60: '60 วัน (ตั๋ว)',
      freightVolume90: '90 วัน (ตั๋ว)',
      freightVolumeGt90: 'มากกว่า 90 วัน (ตั๋ว)',
      // 基础信息
      basicInfo: {
        title: 'ข้อมูลพื้นฐาน',
        relatedBusinessType: 'ประเภทธุรกิจที่เกี่ยวข้อง',
        scac: 'SCAC',
        province: 'จังหวัด',
        city: 'เมือง',
        district: 'เขต'
      }
    },
    // 收发通地址
    mailingAddress: {
      office: 'สาขา',
      lobType: 'ประเภทธุรกิจ',
      partner: 'ลูกค้า/ตัวแทนต่างประเทศ',
      podName: 'ชื่อท่าปลายทาง',
      shipperCode: 'รหัสผู้ส่งของ',
      shipperInfo: 'ข้อมูลผู้ส่งของ',
      consigneeCode: 'รหัสผู้รับของ',
      consigneeInfo: 'ข้อมูลผู้รับของ',
      notifyCode: 'รหัสผู้แจ้ง',
      notifyInfo: 'ข้อมูลผู้แจ้ง',
      shipperName: 'ชื่อผู้ส่งของ',
      consigneeName: 'ชื่อผู้รับของ',
      notifyName: 'ชื่อผู้แจ้ง',
      partner1: 'ลูกค้า',
      pod1: 'ท่าปลายทาง',
      formatManifestInfo: 'ข้อมูลใบตราส่งสินค้าที่จัดรูปแบบ',
      shipper: 'ผู้ส่งของ',
      shipperEnterpriseCode: 'รหัสบริษัทผู้ส่งของ',
      shortCode: 'อักษรย่อรหัส',
      enterpriseCode: 'รหัสบริษัท',
      shipperEnterpriseName: 'ชื่อบริษัทผู้ส่งของ',
      shipperAddress: 'ที่อยู่ผู้ส่งของโดยละเอียด',
      cityName: 'ชื่อเมือง',
      provinceCode: 'รหัสจังหวัด',
      provinceName: 'ชื่อจังหวัด',
      zipCode: 'รหัสไปรษณีย์',
      countryCode: 'รหัสประเทศ',
      aeoEnterpriseCode: 'หมายเลขบริษัท AEO',
      syncFormatInfoToOrder: 'ซิงค์ข้อมูลที่จัดรูปแบบไปยังใบสั่ง',
      consignee: 'ผู้รับของ',
      instructBill: 'ใบตราส่งแบบสั่งจ่าย',
      consigneeEnterpriseCode: 'รหัสบริษัทผู้รับของ',
      consigneeEnterpriseName: 'ชื่อบริษัทผู้รับสินค้า',
      consigneeAddress: 'ที่อยู่ผู้รับสินค้าโดยละเอียด',
      consigneeSpecificContactsName: 'ชื่อผู้ติดต่อโดยตรง',
      consigneeSpecificContacts: 'เบอร์โทรศัพท์ผู้ติดต่อโดยตรง',
      notify: 'ผู้แจ้งเตือน',
      notifyEnterpriseCode: 'รหัสบริษัทผู้แจ้งเตือน',
      notifyEnterpriseName: 'ชื่อบริษัทผู้แจ้งเตือน',
      notifyAddress: 'ที่อยู่ผู้แจ้งเตือนโดยละเอียด',
      shipperPhoneNumber: 'เบอร์โทรศัพท์ผู้ส่งสินค้า',
      shipperEmail: 'อีเมลผู้ส่งสินค้า',
      shipperFax: 'เบอร์โทรสารผู้ส่งสินค้า',
      consigneePhoneNumber: 'เบอร์โทรศัพท์ผู้รับสินค้า',
      consigneeEmail: 'อีเมลผู้รับสินค้า',
      consigneeFax: 'เบอร์โทรสารผู้รับสินค้า',
      consigneeSpecificPhoneNumber: 'เบอร์โทรศัพท์ผู้ติดต่อโดยตรง',
      consigneeSpecificEmail: 'อีเมลผู้ติดต่อโดยตรง',
      consigneeSpecificFax: 'เบอร์โทรสารผู้ติดต่อโดยตรง',
      notifyPhoneNumber: 'เบอร์โทรศัพท์ผู้แจ้งเตือน',
      notifyEmail: 'อีเมลผู้แจ้งเตือน',
      notifyFax: 'เบอร์โทรสารผู้แจ้งเตือน',
      addMailingAddress: 'เพิ่มที่อยู่ผู้ส่ง-รับ-แจ้งเตือน',
      editMailingAddress: 'แก้ไขที่อยู่ผู้ส่ง-รับ-แจ้งเตือน',
      validLobMsg: 'กรุณาเลือกรหัสธุรกิจ',
      validInstructBill: 'ในโหมดใบตราส่งสินค้าที่ผู้รับกำหนด รหัสบริษัทผู้แจ้งเตือนและข้อมูลติดต่อผู้แจ้งเตือนต้องกรอกทั้งคู่',
      fbaWarehouseCode: 'รหัสคลังสินค้าอเมซอน',
      contactName: 'ชื่อผู้ติดต่อ',
      province: 'จังหวัด/รัฐ',
      addr1: 'ที่อยู่ 1',
      addr2: 'ที่อยู่ 2',
      addr3: 'ที่อยู่ 3',
      eoriNo: 'หมายเลข EORI/บริษัท',
      taxNo: 'เลขประจำตัวผู้เสียภาษี',
      ManifestFormatShipper: 'ผู้ส่งสินค้าที่จัดรูปแบบใน manifest',
      TheManifestFormatConsignee: 'ผู้รับสินค้าที่จัดรูปแบบใน manifest',
      ManifestFormatNotifier: 'ผู้แจ้งเตือนที่จัดรูปแบบใน manifest'
    }
  },
  sysManage: { // 系统管理
    baseConfig: { // 基本配置
      triggerTypeManagement: { // 触发类型管理
        addTriggerType: 'เพิ่มประเภททริกเกอร์',
        editTriggerType: 'แก้ไขประเภททริกเกอร์',
        lookTriggerType: 'ดูประเภททริกเกอร์',
        validFieldNameMsg: 'กรุณากรอกชื่อฟิลด์',
        validFieldEnameMsg: 'กรุณากรอกชื่อฟิลด์ภาษาอังกฤษ',
        triggerType: 'ประเภทการอัปเดต',
        fieldCheckType: 'วิธีการตรวจสอบฟิลด์',
        entityCode: 'รหัสเอนทิตี',
        entityName: 'ชื่อเอนทิตี',
        entityEname: 'ชื่อเอนทิตีภาษาอังกฤษ',
        fieldCode: 'รหัสฟิลด์',
        fieldName: 'ชื่อฟิลด์',
        fieldEname: 'ชื่อฟิลด์ภาษาอังกฤษ',
        fieldCheckValue: 'ค่าการตรวจสอบฟิลด์',
        innerDateState: 'สถานะมาจากข้อมูลภายใน',
        outerDateState: 'สถานะมาจากข้อมูลภายนอก',
        applySopNode: 'นำโหนด SOP ไปใช้',
        remark: 'หมายเหตุ'
      },
      routeWareHouseConfiguration: { // 航线与仓库配置
        addRouteWareHouseMapping: 'เพิ่มการกำหนดเส้นทางและคลังสินค้า',
        editRouteWareHouseMapping: 'แก้ไขการกำหนดเส้นทางและคลังสินค้า',
        validRegionCodeMsg: 'กรุณากรอกรหัสเส้นทาง',
        validWarehouseMsg: 'กรุณาเลือกคลังสินค้า',
        regionCode: 'รหัสเส้นทาง',
        warehouse: 'คลังสินค้า',
        remark: 'หมายเหตุ'
      },
      singleOnlineSetting: { // 海运在线对单设置
        branchId: 'สาขา',
        fieldCode: 'รหัสฟิลด์',
        fieldName: 'ชื่อฟิลด์',
        fclEdit: 'อนุญาตให้แก้ไข (คอนเทนเนอร์เต็ม)',
        lclEdit: 'อนุญาตให้แก้ไข (คอนเทนเนอร์รวม)'
      }
    }
  },
  sysMonitor: { // 系统监控
    sopSendLog: {
      orderNo: 'หมายเลขลำดับ',
      relationId: 'เลขที่ธุรกิจ',
      dateCreated: 'เวลาที่ส่ง',
      type: 'ประเภท',
      pushNode: 'โหนดการส่ง',
      pushingChannel: 'ช่องทางการส่ง',
      pushingResult: 'ผลการส่ง',
      receivingUser: 'ผู้รับ',
      receivingTxt: 'คำอธิบายเนื้อหา',
      modifyDate: 'เวลาการเปลี่ยนแปลง SOP',
      file: 'ไฟล์'
    }
  },
  common: {
    defaultPlaceholder: 'คำค้นหา',
    BeginDate: 'วันที่เริ่มต้น',
    EndDate: 'วันที่สิ้นสุด',
    pagePer: 'รายการ/หน้า',
    pleaseChoose: 'กรุณาเลือก',
    confirm: 'ยืนยัน',
    reset: 'รีเซ็ต',
    cancel: 'ยกเลิก',
    tips: {
      fuzzySearch: 'กรุณากรอกรหัส ชื่อ หรืออื่นๆ สำหรับการค้นหาแบบคลุมเครือ',
      fuzzyCodeSearch: 'กรุณากรอกรหัสสำหรับการค้นหาแบบคลุมเครือ',
      fuzzyModelSearch: 'กรุณากรอกประเภทเครื่องบินสำหรับการค้นหาแบบคลุมเครือ',
      overseaWarehouseFuzzySearch: 'กรุณากรอกรหัสคลังสินค้าต่างประเทศสำหรับการค้นหาแบบคลุมเครือ',
      fuzzySearchForJudgment: 'กรุณากรอกหมายเลขลำดับ หรือเหตุผลการตัดสินสำหรับการค้นหาแบบคลุมเครือ',
      fuzzySearchForCustomEqType: 'กรุณากรอกขนาด หรือประเภทคอนเทนเนอร์สำหรับการค้นหาแบบคลุมเครือ',
      hasOneAtleast: 'กรุณาเลือกอย่างน้อยหนึ่งรายการ',
      hasOneAtleastAudit: 'กรุณาเลือกอย่างน้อยหนึ่งรายการที่ผ่านการตรวจสอบ',
      hasOneOnly: 'กรุณาเลือกเพียงหนึ่งรายการ',
      cannotDeleteBranch: 'ไม่สามารถลบสาขาที่สร้างโดยแผนค่าบริการ!',
      saveSuccess: 'บันทึกสำเร็จ!',
      prompt: 'แจ้งเตือน',
      systemPrompt: 'แจ้งเตือนจากระบบ',
      confirmDelete: 'ยืนยันการลบรายการนี้หรือไม่?',
      confirmCheck: 'ยืนยันการตรวจสอบรายการหรือไม่?',
      confirmCancelCheck: 'ยืนยันการยกเลิกการตรวจสอบรายการหรือไม่?',
      confirm: 'ยืนยัน',
      deleteSuccess: 'ลบสำเร็จ!',
      editSuccess: 'แก้ไขสำเร็จ!',
      deleteFail: 'ลบไม่สำเร็จ!',
      cancelDelete: 'ยกเลิกการลบ!',
      yes: 'ใช่',
      no: 'ไม่',
      repeatedlyTip: 'เพิ่มซ้ำ',
      pleaseChoose: 'กรุณาเลือก',
      isAdded: 'เพิ่มแล้วหรือไม่',
      resetSuccess: 'รีเซ็ตสำเร็จ!',
      warning: 'คำเตือน',
      branchSame: 'ข้อมูลที่กำลังดำเนินการอยู่ไม่ได้อยู่ในสาขาปัจจุบันหรือสาขาระดับบน!'
    },
    btn: {
      refresh: 'รีเฟรช',
      query: 'ค้นหา',
      look: 'ดู',
      new: 'เพิ่มใหม่',
      add: 'เพิ่ม',
      edit: 'แก้ไข',
      editAgain: 'แก้ไขใหม่',
      delete: 'ลบ',
      exportExcel: 'ส่งออก Excel',
      downLoadTemplate: 'ดาวน์โหลดเทมเพลต',
      save: 'บันทึก',
      cancel: 'ยกเลิก',
      ok: 'ตกลง',
      confirm: 'ยืนยัน',
      back: 'กลับ',
      audit: 'ตรวจสอบ',
      reject: 'ปฏิเสธ',
      reset: 'รีเซ็ต',
      close: 'ปิด',
      yes: 'ใช่',
      no: 'ไม่',
      next: 'ขั้นตอนต่อไป',
      confirmUpdate: 'ยืนยันการแก้ไข',
      enable: 'เปิดใช้งาน',
      disable: 'ปิดใช้งาน'
    },
    createBy: 'ผู้สร้าง',
    dateCreated: 'เวลาที่สร้าง',
    modifiedBy: 'ผู้แก้ไข',
    dateModified: 'เวลาที่แก้ไข'
  },
  // 常量
  constant: {
    all: 'ทั้งหมด',
    yes: 'ใช่',
    no: 'ไม่',
    greaterThan: 'มากกว่า',
    lessThan: 'น้อยกว่า',
    equal: 'เท่ากับ',
    email: 'อีเมล',
    note: 'ข้อความ',
    sop: { // sop 常量

      JOB_NO: 'เลขที่ธุรกิจ',
      CUSTOMER_ID: 'หน่วยงานที่มอบหมาย',
      CUSTOMER_ID_CN: 'หน่วยงานผู้มอบหมาย (ภาษาจีน)',
      CUSTOMER_ID_US: 'หน่วยงานผู้มอบหมาย (ภาษาอังกฤษ)',
      CARRIER_CN: 'บริษัทเรือ (ภาษาจีน)',
      CARRIER_US: 'บริษัทเรือ (ภาษาอังกฤษ)',
      CARRIER_CODE: 'บริษัทเรือ (รหัส)',
      CARRIER_SHORT_NAME: 'บริษัทเรือ (ชื่อย่อ)',
      DESTINATION_AGENT: 'ตัวแทนท่าเรือปลายทาง',
      DESTINATION_AGENT_SHORT_NAME: 'ตัวแทนท่าเรือปลายทาง (ชื่อย่อ)',
      DESIGNATION_AGENT: 'ตัวแทนสินค้าที่กำหนด',
      BARGE_POL: 'ท่าเรือเริ่มต้นของเรือบรรทุก',
      LOADING_PORT_CODE: 'ท่าเรือเริ่มต้น',
      LOADING_PORT_CODE3: 'รหัสท่าเรือเริ่มต้น',
      DESTINATION_PORT_CODE: 'ท่าปลายทาง',
      DESTINATION_PORT_CODE2: 'รหัสท่าเรือปลายทาง',
      VESSEL: 'ชื่อเรือ',
      VOYAGE: 'เที่ยวเรือ',
      BRANCH_VESSEL: 'ชื่อเรือบรรทุกสาขา',
      BRANCH_VOYAGE: 'เที่ยวเรือบรรทุกสาขา',
      WAREHOUSE_NO: 'หมายเลขเข้าโกดัง',
      SO_NO: 'S/O NO.',
      MBL: 'MB/L NO',
      HBL_NO: 'HB/L NO',
      ETD: 'ETD',
      ETA: 'ETA',
      ATD: 'ATD',
      ATA: 'ATA',
      CUSTOMS_DATE: 'วันที่ดำเนินการ',
      CONSIGNEE_CODE: 'ผู้รับของ',
      CUSTOMER_REF_NO: 'หมายเลขอ้างอิงธุรกิจ',
      USER_DEFINED_FIELD1: 'ฟิลด์กำหนดเอง 1',
      USER_DEFINED_FIELD2: 'ฟิลด์กำหนดเอง 2',
      USER_DEFINED_FIELD3: 'ฟิลด์กำหนดเอง 3',
      USER_DEFINED_FIELD4: 'ฟิลด์กำหนดเอง 4',
      ESTIMATED_SHIPPING_DATE: 'กำหนดการเรือโดยประมาณ',
      CSR: 'บริการลูกค้า',
      CSR_PHONE: 'โทรศัพท์บริการลูกค้า',
      CSR_EMAIL: 'อีเมลบริการลูกค้า',
      OVERSEA_OP_EMAIL: 'อีเมลบริการลูกค้าต่างประเทศ',
      DC_EMAIL: 'อีเมลเอกสาร',
      PORT_DISTRICT: 'เขตท่าเรือ',
      TERMINAL_OPENDATE: 'วันที่เปิดท่าเรือ',
      TERMINAL_CUTOFF: 'วันที่ปิดท่าเรือ',
      REAL_ARRIVALS_DATE: 'วันที่เข้าเทียบท่าจริง',
      BERTH_PLAN_DATE: 'วันที่วางแผนเทียบท่า',
      ACTUAL_BERTH_PLAN_DATE: 'วันที่เทียบท่าจริง',
      UN_BERTH_PLAN_DATE: 'วันที่วางแผนออกจากท่า',
      ACTUAL_UN_BERTH_PLAN_DATE: 'วันที่ออกจากท่าจริง',
      BERTH_PLAN_PLACE: 'ท่าเทียบเรือตามแผน',
      ACTUAL_BERTH_PLAN_PLACE: 'ท่าเทียบเรือจริง',
      OP_EMAIL: 'อีเมลดำเนินการ',
      DESTINATION_AGENT_EMAIL: 'อีเมลติดต่อเริ่มต้นของตัวแทนท่าเรือปลายทาง',
      SINGLE_ADDRESS: 'ที่อยู่ตรวจสอบเอกสาร',
      CUTOFF_TIME: 'วันที่ปิดรับเอกสาร',
      EstimatedArrivalTime: 'เวลาถึงท่าเรือโดยประมาณ',
      actualArrivalTime: 'เวลาถึงท่าเรือจริง',
      PortDischargeTime: 'เวลาขนถ่ายสินค้า',
      ActualLiftingDate: 'เวลารับสินค้าจริง',
      ActualReturnTime: 'เวลาคืนตู้จริง',
      MBLTransportationClause: 'เงื่อนไขการขนส่งใบตราส่งหลัก',
      HBLTransportationClause: 'เงื่อนไขการขนส่งใบตราส่งย่อย',
      MasterBLFreightTerm: 'เงื่อนไขค่าขนส่งใบตราส่งหลัก',
      HBLFreightClause: 'เงื่อนไขค่าขนส่งใบตราส่งย่อย',
      MORE_DOOR_QUANTITY: 'จำนวนพัสดุหลายจุดส่ง',
      ROUGH_WEIGHT: 'น้ำหนักรวมหลายจุดส่ง',
      MORE_DOOR_VOLUME: 'ปริมาตรหลายจุดส่ง',
      PACKAGING_TYPE: 'ประเภทบรรจุภัณฑ์',
      SHIPPER_CODE: 'HBL Shipper Code',
      BUSINESS_MODEL: 'รูปแบบธุรกิจ',
      TICKET_RECEIPT: 'ใบตราส่งหลัก/ใบตราส่งย่อย',
      NO_LISTING: 'รายการหมายเลขตู้จุดส่ง',
      ESTIMATED_DELIVERY_DATE: 'วันที่คาดว่าจะส่งของถึงจุดส่ง',
      UNLOADING_WAY: 'วิธีการขนถ่ายสินค้าที่จุดส่ง',
      PO: 'PO',
      CNEE_CODE: 'HBL CNEE Code',
      ADDRESS: 'ที่อยู่จุดส่ง',
      BASIC_NUMBER: 'แท็บพื้นฐาน-จำนวนพัสดุ',
      BASIC_ROUGH_WEIGHT: 'แท็บพื้นฐาน-น้ำหนักรวม',
      BASIC_VOLUME: 'แท็บพื้นฐาน-ปริมาตร',
      DELIVER_DATE: 'วันที่รับสินค้า',
      ARRIVE_STORAGE_DATE: 'วันที่ถึงคลัง',
      TRANS_DATE: 'วันที่เปลี่ยนใบตราส่ง',
      CUSTOMER_REF_NO2: 'หมายเลขอ้างอิงลูกค้า',
      LOADING_PORT_CODE2: 'ท่าเรือบรรทุก',
      CARRIER_ID: 'สายการบิน',
      CARRIER_ID_CN: 'สายการบิน (ภาษาจีน)',
      CARRIER_ID_US: 'สายการบิน (ภาษาอังกฤษ)',
      VOYAGE_FLIGHT: 'เที่ยวบิน',
      ETD2: 'วันที่ออกเดินทาง',
      ETA2: 'วันที่ถึงท่าเรือ',
      WAREHOUSE_NO2: 'หมายเลขเข้าโกดัง',
      QUANTITY: 'จำนวนพัสดุ (เข้าโกดัง)',
      WEIGHT: 'น้ำหนักรวม (เข้าโกดัง)',
      VOLUME: 'ปริมาตร (เข้าโกดัง)',
      TRANSPORTATION_COMPANY: 'บริษัทขนส่ง',
      CONTAINER_NO: 'หมายเลขตู้',
      SEAL_NO: 'หมายเลขซีล',
      EMPTY_CABINET_WEIGHT: 'น้ำหนักตู้เปล่า',
      ESTIMATED_DATE: 'วันที่คาดว่าจะบรรจุตู้ (ถึงโรงงาน)',
      ACTUAL_PACKING: 'การบรรจุตู้จริง (ถึงโรงงาน)',
      CONTAINER_DESC: 'คำอธิบายปริมาณตู้',
      EXPECTED_ARRIVAL_DATE: 'วันที่คาดว่าจะถึง',
      ACTUAL_ARRIVAL_DATE: 'วันที่ถึงจริง',
      CUSTOMER_DOOR_POINT: 'จุดส่งลูกค้า',
      CUSTOMER_PORTAL_ADDRESS: 'จุดส่งลูกค้า',
      DESTINATION_GATE_POINT: 'จุดส่งปลายทาง',
      ADDRESS_OF_DESTINATION_GATE_POINT: 'ที่อยู่จุดส่งปลายทาง',
      WAREHOUSE_SUPPLIER: 'ผู้ให้บริการคลังสินค้า',
      WAREHOUSE_NAME: 'ชื่อคลังสินค้า',
      DOWNLOAD_URL: 'ลิงก์ดาวน์โหลดใบบันทึกล่วงหน้า',
      MBL2: 'MAWB NO',
      HAWB: 'HAWB NO',
      DISCHARGING_PORT: 'ท่าเรือขนถ่าย',
      DISCHARGING_PORT2: 'รหัสท่าเรือขนถ่ายสินค้า',
      WAREHOUSE_DATA: 'ข้อมูลการนำสินค้าเข้าโกดัง',
      STATUS_UPDATE_TIME: 'เวลาการเปลี่ยนแปลงสถานะ',
      QUANTITY_CONTRACT: 'จำนวนพัสดุที่มอบหมาย',
      WEIGHT_CONTRACT: 'น้ำหนักรวมที่มอบหมาย',
      CUBAGE_CONTRACT: 'ปริมาตรที่มอบหมาย',
      TRUST_FROM_JOB: 'เลขที่อ้างอิงการมอบหมาย',
      RELATED_JOB: 'เลขที่อ้างอิงการติดต่อ',
      BASIC_SHIPPER_CODE: 'รหัสผู้ส่งสินค้าพื้นฐาน',
      BASIC_CONSIGNEE_CODE: 'รหัสผู้รับสินค้าพื้นฐาน',
      INCOTERMS: 'เงื่อนไขการค้า',
      CHARGE_WEIGHT: 'น้ำหนักคิดค่าบริการ',
      PACKAGE: 'บรรจุภัณฑ์',
      REMARK: 'หมายเหตุ',
      POD: 'สถานที่ส่งมอบ',
      LOADING_PORT_CODE4: 'รหัสท่าเรือบรรทุกสินค้า',

      MBLNO: 'เลขที่ใบสำคัญหลัก',
      CONTACT: 'ผู้ติดต่อ',
      AIR_LINE: 'เส้นทางเดินเรือ',
      TRANSPORT_TYPE: 'ประเภทการขนส่ง',
      DEPARTURE_STATION: 'สถานีต้นทาง',
      DEPARTURE_STATION_CODE: 'รหัสสถานีต้นทาง',
      DESTINATION_STATION: 'สถานีปลายทาง',
      DESTINATION_STATION_CODE: 'รหัสสถานีปลายทาง',
      TRANSIT_STATION: 'สถานีผ่าน',
      TRANSIT_STATION_CODE: 'รหัสสถานีผ่าน',
      PAYMENT_METHOD: 'วิธีการชำระเงิน',
      TRACK_NO: 'เลขที่ใบส่งสินค้า',
      SHUTTLE: 'รถประจำทาง',
      TRAIN_NO: 'เที่ยวรถ',
      QUANTITY_ACTUAL: 'จำนวนพัสดุจริง',
      WEIGHT_ACTUAL: 'น้ำหนักรวมจริง',
      CUBAGE_ACTUAL: 'ปริมาตรจริง',
      CARGO_CHINESE_NAME_BASE: 'ชื่อสินค้า (พื้นฐาน) ภาษาจีน',
      CARGO_ENGLISH_NAME_BASE: 'ชื่อสินค้า (พื้นฐาน) ภาษาอังกฤษ',
      CARGO_ENGLISH_NAME: 'ชื่อสินค้า ภาษาอังกฤษ',
      SALES: 'การขาย',
      SALES_EMAIL: 'อีเมลฝ่ายขาย',
      // 新增毛体重
      ACTUAL_PIECE: 'จำนวนพัสดุ (จริง)',
      ACTUAL_WEIGHT: 'น้ำหนักรวม (จริง)',
      ACTUAL_VOLUME: 'ปริมาตร (จริง)',
      CUSTOMER_SERVICE: 'บริการลูกค้า',
      DOCUMENT: 'เอกสาร',
      ROUTE_MANAGER: 'ผู้รับผิดชอบเส้นทางเดินเรือ',
      OVERSEAS_CUSTOMER_SERVICE: 'บริการลูกค้าต่างประเทศ',
      ROUTE_MANAGER_EMAIL: 'อีเมลผู้รับผิดชอบเส้นทางเดินเรือ',
      INTEGRATION_TYPE: 'ประเภทการรวม/แยกสินค้า',
      ROUTE_LEADER: 'ผู้รับผิดชอบเส้นทาง',
      ROUTE_LEADER_EMAIL: 'อีเมลผู้รับผิดชอบเส้นทาง',
      OPERATE: 'การดำเนินการ',
      MBLCMR: 'หมายเลขใบตราส่งหลัก',
      DISCHARGING_PLACE: 'สถานที่จัดส่ง',
      LOADING_PORT: 'จุดเริ่มต้นการขนส่ง',
      DESTINATION_PORT: 'จุดหมายปลายทาง',
      DOMESTIC_PLATE_NUMBER: 'ป้ายทะเบียนรถภายในประเทศ',
      KH_PLATE_NUMBER: 'ป้ายทะเบียนรถบรรทุก',
      KH_TRAILER_NUMBER: 'หมายเลขพ่วงรถบรรทุก',
      VOYAGE_FLIGHT_NO: 'หมายเลขเที่ยวบิน',
      BOOKING_DATE: 'วันที่จองพื้นที่บรรทุก',
      ACTUAL_ENTRY_TIME: 'เวลาที่เข้าจริง',
      ACTUAL_LOADING_TIME: 'เวลาบรรทุกจริง',
      ESTIMATED_DEPARTURE_TIME: 'เวลาออกเดินทางตามกำหนด',
      ACTUAL_DEPARTURE_TIME: 'เวลาออกเดินทางจริง',
      ESTIMATED_ARRIVAL_TIME: 'เวลาถึงตามกำหนด',
      ACTUAL_ARRIVAL_TIME: 'เวลาถึงจริง',
      ACTUAL_RECEIVING_TIME: 'เวลารับเอกสารจริง',
      ACTUAL_UNLOADING_TIME: 'เวลาขนถ่ายสินค้าจริง',
      ACTUAL_ARRIVAL_NOTIFICATION_TIME: 'เวลาแจ้งถึงสินค้าจริง',
      ACTUAL_PICKUP_TIME: 'เวลารับสินค้าจริง',
      SECOND_FLIGHT: 'หมายเลขเที่ยวบิน (ข้อมูลเที่ยวบินที่สอง)',
      ESTIMATED_TRANSFER_ARRIVAL_TIME: 'เวลาถึงจุดเปลี่ยนตามกำหนด (ข้อมูลเที่ยวบินที่สอง)',
      TRANSFER_ARRIVAL_TIME: 'เวลาถึงจุดเปลี่ยนจริง (ข้อมูลเที่ยวบินที่สอง)',
      ESTIMATED_TRANSFER_DEPARTURE_TIME: 'เวลาออกเดินทางจากจุดเปลี่ยนตามกำหนด (ข้อมูลเที่ยวบินที่สอง)',
      TRANSFER_DEPARTURE_TIME: 'เวลาออกเดินทางจากจุดเปลี่ยนจริง (ข้อมูลเที่ยวบินที่สอง)',
      Warehouse_Address: 'ที่อยู่คลังสินค้า',
      Actual_Ship_Date: 'วันที่ส่งออกจริง (ATD)',
      Customs_Brokers: 'บริษัทศุลกากร',
      Actual_Arrival_Date: 'วันที่ถึงจริง (ATA)',
      Actual_Packing_Date: 'วันที่บรรจุหีบห่อจริง',
      Door_Point: 'จุดรับส่ง',
      Additional_Notes: 'คำอธิบายเพิ่มเติม',
      Estimated_Delivery_Time: 'เวลาส่งมอบตามกำหนด',
      Actual_Delivery_Time: 'เวลาส่งมอบจริง',
      PACKING: 'บรรจุภัณฑ์',
      PACKING_CN: 'บรรจุภัณฑ์ (ภาษาจีน)',
      PACKING_US: 'บรรจุภัณฑ์ (ภาษาอังกฤษ)',
      TYPE_OF_GOODS: 'ประเภทสินค้า',
      TYPE_OF_GOODS_CODE: 'ประเภทสินค้า (รหัส)',
      MAIN_PAYMENT_LOCATION: 'สถานที่ชำระเงินใบตราส่งหลัก',
      MARK: 'เครื่องหมายการค้า',
      HS_NUMBER: 'รหัส HS',
      CUSTOM_POSITION_1: 'ตำแหน่งกำหนดเอง 1',
      CUSTOM_POSITION_2: 'ตำแหน่งกำหนดเอง 2',
      TRANSIT_PORT: 'ท่าเรือเปลี่ยนถ่าย',
      BOOKING_NUMBER: 'หมายเลขการจองพื้นที่บรรทุก',
      SHIPPING_NUMBER: 'หมายเลขสัญญาบริษัทเรือ',
      BARGES_REMARKS: 'หมายเหตุข้อมูลเรือบรรทุกสาขา',
      MBL_SHIPPER: 'ผู้ส่งของ MB/L',
      MBL_CONSIGNEE: 'ผู้รับของ MB/L',
      MBL_NOTIFIER: 'ผู้แจ้ง MB/L'
    },
    nodeType: {
      lodingPort: 'ท่าเรือเริ่มต้น',
      transferPort: 'ท่าเรือเปลี่ยนถ่าย',
      destinationPort: 'ท่าปลายทาง',
      warehousing: 'คลังสินค้า',
      booking: 'จองพื้นที่บรรทุก',
      entrust: 'มอบหมาย',
      container: 'ทำตู้คอนเทนเนอร์',
      distribution: 'การจัดส่ง',
      supplement: 'เติมเต็ม'
    },
    // 推送渠道
    pushingChannel: {
      all: 'ทั้งหมด',
      email: 'อีเมล',
      msg: 'ข้อความ'
    },
    // sop类型
    sopTypes: {
      all: 'ทั้งหมด',
      sopSend: 'การส่ง SOP',
      innerSend: 'การส่งภายใน'
    },
    // 推送结果
    pushResult: {
      all: 'ทั้งหมด',
      success: 'สำเร็จ',
      fail: 'ล้มเหลว'
    },
    // 系统常量
    systemConstants: {
      SE: 'การส่งออกทางทะเล',
      SI: 'การนำเข้าทางทะเล',
      AE: 'การส่งออกทางอากาศ',
      AI: 'การนำเข้าทางอากาศ',
      RE: 'การส่งออกทางรถไฟ',
      RI: 'การนำเข้าทางรถไฟ',
      RB: 'บริการรถไฟ',
      IE: 'โลจิสติกส์แบบบูรณาการ',
      FBASE: 'FBA ทางทะเล',
      FBAAE: 'FBA ทางอากาศ',
      FBARE: 'FBA ทางรถไฟ'
    },
    // 提单流水号类型
    BillType: {
      MBL: 'ใบสำคัญหลัก',
      HBL: 'ใบสำคัญย่อย'
    },
    // 进口业务常量
    importConstants: {
      FCL: 'ตู้เต็ม',
      LCL: 'ตู้รวม',
      CON: 'การรวมตู้',
      POJ: 'โครงการ',
      PVE: 'ของส่วนตัว',
      ECL: 'มอบหมายตู้รวม',
      BULK: 'สินค้าเบ็ดเตล็ด',
      CONSOLE: 'หนึ่งหลักหลายย่อย',
      DIRECT: 'ใบสำคัญตรง',
      BACK_TO_BACK: 'หนึ่งหลักหนึ่งย่อย'
    },
    // 空运出口常量
    airExportConstants: {
      CONSOLE: 'หนึ่งหลักหลายย่อย',
      DIRECT: 'ใบสำคัญตรง',
      BACK_TO_BACK: 'หนึ่งหลักหนึ่งย่อย'
    },
    // 海运出口常量
    seaExportConstants: {
      CONTRACT_STATE_NO: 'ยังไม่เซ็นสัญญา',
      CONTRACT_STATE_OUT_OF_DATE: 'สัญญาหมดอายุ',
      CONTRACT_STATE_SIGNED: 'เซ็นสัญญาแล้ว'
    },
    templateRuleName: {
      CUSTOMER_CN_NAME: 'ชื่อจีนของลูกค้า',
      CUSTOMER_SHORT_NAME: 'ชื่อย่อของลูกค้า',
      SETTLEMENT_CN_NAME: 'ชื่อจีนของวัตถุการชำระเงิน',
      SETTLEMENT_SHORT_NAME: 'ชื่อย่อผู้รับชำระเงิน',
      BOOKING_AGENT_CN_NAME: 'ตัวแทนจองพื้นที่เรือ (ภาษาจีน)',
      BOOKING_AGENT_SHORT_NAME: 'ชื่อย่อตัวแทนจองพื้นที่เรือ',
      LOB_NO: 'เลขที่ธุรกิจ',
      MBL_NO: 'MBL NO',
      HBL_NO: 'HBL NO',
      REF_NO: 'เลขที่ใบศุลกากร',
      BILL_NO: 'เลขที่ใบแจ้งหนี้',
      BILL_PAYMENT_NO: 'เลขที่การชำระเงิน',
      WAREHOUSE_NO: 'เลขที่รับเข้าคลัง',
      PONO: 'เลขที่โครงการ',
      CUSTOMER_REF_NO: 'หมายเลขอ้างอิงธุรกิจ',
      PLATE_NUMBER_DOOR: 'ป้ายทะเบียนรถ (จุดรับส่งปัจจุบัน)',
      PLATE_NUMBER_DEST: 'ป้ายทะเบียนรถ (จุดหมายปลายทางปัจจุบัน)',
      CARRIER_CN_NAME: 'ชื่อบริษัทเรือ (ภาษาจีน)',
      CARRIER_SHORT_NAME: 'ชื่อย่อบริษัทเรือ',
      ETD: 'วันที่เรือออกตามกำหนด',
      DESTINATION_PORT_CODE: 'ท่าปลายทาง',
      DESTINATION_PORT_CODE_CODE: 'รหัสท่าเรือปลายทาง'
    },
    genDocCondition: {
      FormalHbl: 'ใบแยกรูปแบบ'
    },
    buttonName: {
      FormalHbl: 'ใบแยกรูปแบบ'
    }
  },
  // 枚举参数
  parameter: {
    // 集装箱装载类型
    containerLoadType: {
      FCL: 'ตู้เต็ม',
      LCL: 'ตู้รวม',
      BB: 'มอบหมายตู้รวม',
      BC: 'Buyer Console',
      BULK: 'สินค้าเบ็ดเตล็ด',
      SPA: 'ตู้สินค้าเฉพาะ'
    },
    // 合作伙伴服务项目
    partnerServiceItem: {
      ALL: 'ทั้งหมด',
      CUSTOMER: 'ลูกค้า',
      BOOKING_AGENT: 'ตัวแทนจองพื้นที่เรือ',
      OVERSEA_AGENT: 'ตัวแทนท่าเรือปลายทาง',
      DESIGNATION_AGENT: 'ตัวแทนสินค้าที่กำหนด',
      LOCAL: 'ตัวแทนท้องถิ่น',
      SETTLEMENT_AGENT: 'ตัวแทนชำระเงิน',
      SEA_CMP: 'บริษัทเรือ',
      AIR_CMP: 'สายการบิน',
      SEA_CMP_AGENT: 'ตัวแทนเรือ',
      CUSTOMS_BROKER: 'บริษัทศุลกากร',
      TRUCK_CMP: 'บริษัทขนส่งทางรถ',
      WAREHOUSE: 'คลังสินค้า',
      GLOBAL: 'บริษัทกลุ่ม',
      SHIPPER: 'ผู้ส่งของ',
      CONSIGNEE: 'ผู้รับของ',
      NOTIFY: 'ผู้แจ้งเตือน',
      PORT_AGENT: 'ตัวแทนด่าน',
      FORWARDING_AGENT: 'ตัวแทนจัดส่ง',
      LOADINGPLACE_COMPANY: 'บริษัทจุดบรรทุกสินค้า',
      SIGNBILLPLACE_COMPANY: 'บริษัทจุดลงนาม',
      DISCHARGEPORT_COMPANY: 'บริษัทท่าเรือขนถ่าย',
      DESTINATIONPORT_COMPANY: 'บริษัทท่าเรือปลายทาง',
      OTHER: 'อื่นๆ'
    },
    // 角色类型
    roleType: {
      SALES_TYPE: 'การขาย',
      CSR_TYPE: 'บริการลูกค้า',
      DOC_TYPE: 'เอกสาร',
      OVERSEAOP_TYPE: 'บริการลูกค้าต่างประเทศ',
      SALES_OF_GOODS: 'การขายและการรวบรวมสินค้า'
    }
  },
  advanceSearchForm: { // 高级查询组件
    ...thTH,
    advSearchBtn: 'การค้นหาขั้นสูง',
    quickSearch: 'การค้นหาอย่างรวดเร็ว',
    more: 'เงื่อนไขเพิ่มเติม',
    Equal: 'เท่ากับ',
    Unequal: 'ไม่เท่ากับ',
    Greater: 'มากกว่า',
    Less: 'น้อยกว่า',
    Like: 'ประกอบด้วย',
    Not_Like: 'ไม่ประกอบด้วย',
    Batch: 'เป็นชุด',
    BatchExclude: 'ยกเว้นเป็นชุด',
    Regexp: 'REGEXP',
    In: 'ประกอบด้วย',
    Range: 'ช่วง',
    Not_In: 'ไม่ประกอบด้วย',
    Is_Not_Null: 'ไม่ว่างเปล่า',
    Is_Null: 'ว่างเปล่า',
    Is_It_Empty: 'ว่างเปล่าหรือไม่',
    Date_Item: 'ตัวเลือกด่วน',
    customer: { // 客商
      level: 'ระดับลูกค้า',
      chineseName: 'ชื่อภาษาจีน',
      status: 'สถานะลูกค้า'
    },
    bookingNew: { // 海运订舱极速版
      destinationCountry: 'ประเทศท่าเรือปลายทาง',
      hblCheckingStatus: 'สถานะการตรวจสอบ HBL',
      hblBlType: 'วิธีการ提单 HBL',
      hblBillOfLadingNumber: 'หมายเลขซีเรียล提单 HBL',
      hblReleasingStatus: 'สถานะการปล่อย提单 HBL',
      hblBlType2: 'ประเภท提单 HBL',
      mblCheckingStatus: 'สถานะการตรวจสอบ MBL',
      mblBlType: 'วิธีการ提单 MBL',
      mblBillOfLadingNumber: 'หมายเลขซีเรียล提单 MBL',
      overseaCustomerService: 'บริการลูกค้าต่างประเทศ',
      customerLevel: 'ระดับลูกค้า',
      isSignContract: 'มีการเซ็นสัญญาหรือไม่',
      userDefinedField1: 'ฟิลด์กำหนดเอง 1',
      userDefinedField2: 'ฟิลด์กำหนดเอง 2',
      userDefinedField3: 'ฟิลด์กำหนดเอง 3',
      opOffice: 'สาขาดำเนินการ',
      salesOffice: 'สาขาขาย',
      bookingAgentIsNull: 'ตัวแทนจอง舱ว่างเปล่า'
    },
    shortcut: 'ตัวเลือกด่วน',
    daterange: 'ช่วง',
    lt: 'น้อยกว่า',
    gt: 'มากกว่า',
    eq: 'เท่ากับ',
    notEq: 'ไม่เท่ากับ',
    like: 'ประกอบด้วย',
    draft: 'ฉบับร่าง',
    commit: 'ส่ง',
    check: 'ตรวจสอบ',
    createDate: 'วันที่สร้าง',
    nowWeek: 'สัปดาห์นี้',
    preWeek: 'สัปดาห์ที่แล้ว',
    nextWeek: 'สัปดาห์หน้า',
    nowMonth: 'เดือนนี้',
    preMonth: 'เดือนที่แล้ว',
    nextMonth: 'เดือนหน้า',
    doubleClickToSelect: 'ดับเบิลคลิกที่ช่องข้อความเพื่อเลือกการสอบถามสถานะโหนด',
    fitAll: 'ตรงตามทั้งหมดต่อไปนี้',
    fitAny: 'ตรงตามข้อใดข้อหนึ่งต่อไปนี้'
  },
  route: {
    dashboard: 'หน้าแรก',
    baseInfo: 'ข้อมูลพื้นฐาน',
    seaport: 'ท่าเรือ',
    airport: 'ท่าอากาศยาน',
    airlineCode: 'รหัสสายการบิน',
    operationRequirementDescribe: 'คำอธิบายข้อกำหนดการดำเนินการ',
    city: 'เมือง',
    basicData: 'ข้อมูลพื้นฐาน',
    customsCommodityCode: 'รหัสสินค้าศุลกากร',
    usCommodityCode: 'รหัสสินค้าสหรัฐอเมริกา',
    country: 'ประเทศ',
    rateManagement: 'การจัดการอัตราแลกเปลี่ยน',
    chargeService: 'รายการค่าใช้จ่าย',
    costPlan: 'แผนค่าบริการ',
    guarantee: 'หนังสือค้ำประกัน',
    payService: 'รายการค่าใช้จ่าย',
    partner: 'พันธมิตร',
    mailingAddress: 'ที่อยู่สำหรับรับ-ส่ง',
    seaPortRequirement: 'ข้อกำหนดท่าเรือ (ท่าเรือ)',
    airPortRequirement: 'ข้อกำหนดท่าเรือ (ท่าอากาศยาน)',
    partnerInformationImport: 'นำเข้าข้อมูลพันธมิตร',
    seaExport: 'การส่งออกทางทะเล',
    bookingNew: 'เวอร์ชันด่วนสำหรับการจองตู้ขนส่งทางทะเล',
    ProjectManage: 'การจัดการโครงการ',
    project: 'โครงการ',
    order: 'การจัดการคำสั่งซื้อ',
    warehousing: 'การจัดการคลังสินค้าเข้า',
    inventory: 'การจัดการสินค้าคงคลัง',
    seaImport: 'การนำเข้าทางทะเล',
    airExport: 'การส่งออกทางอากาศ',
    seaImportBooking: 'การดำเนินการทางทะเล',
    airExportBooking: 'การจองตู้ขนส่งทางอากาศ',
    airImportBooking: 'การดำเนินการทางอากาศ',
    railwayExport: 'การส่งออกทางรถไฟ',
    integratedJob: 'โลจิสติกส์แบบบูรณาการ',
    remoteBooking: 'การจองตู้ขนส่งระยะไกล',
    prediction: 'พยากรณ์',
    preBooking: 'การตรวจสอบล่วงหน้าสำหรับการจองตู้',
    preOrder: 'การตรวจสอบคำสั่งซื้อล่วงหน้า'
  },
  navbar: {
    screenfull: 'เต็มหน้าจอ',
    logOut: 'ออกจากระบบ',
    dashboard: 'หน้าแรก',
    github: 'ที่อยู่โครงการ',
    theme: 'เปลี่ยนธีม',
    size: 'ขนาดเลย์เอาต์'
  },
  login: {
    title: 'เข้าสู่ระบบ',
    logIn: 'เข้าสู่ระบบ',
    username: 'บัญชีผู้ใช้',
    password: 'รหัสผ่าน'
  },
  act: {
    billing: {
      pleaseSelectBilling: 'กรุณาเลือกบิล!',
      hasConfirmed: 'บิล【{0}】ได้รับการยืนยันแล้ว!',
      hasReviewed: 'บิล【{0}】ได้รับการตรวจสอบแล้ว!',
      hasBillingGroup: 'บิล【{0}】ได้ทำการตรวจสอบบัญชีแล้ว!',
      hasInvoice: 'บิล【{0}】ได้ออกใบแจ้งหนี้แล้ว!',
      hasWriteOff: 'บิล【{0}】ได้ทำการตัดจ่ายแล้ว!',
      confirmDelete: 'ยืนยันที่จะลบบิลจำนวน {0} รายการนี้หรือไม่?',
      noConfirmBill: 'ไม่มีบิลที่สามารถยืนยันได้!',
      noRecheckBill: 'ไม่มีบิลที่สามารถตรวจสอบได้!',
      noCancelRecheckBill: 'ไม่มีบิลที่สามารถยกเลิกการยืนยันได้!',
      batchConfirmBill: 'ยืนยันที่จะยืนยันบิลจำนวน {0} รายการพร้อมกันหรือไม่?',
      batchRecheckBill: 'ยืนยันที่จะตรวจสอบบิลจำนวน {0} รายการพร้อมกันหรือไม่?',
      noCancelConfirmBill: 'ไม่มีบิลที่สามารถยกเลิกการยืนยันได้!',
      confirmCancelBill: 'ยืนยันที่จะยกเลิกการยืนยันบิลจำนวน {0} รายการหรือไม่?',
      cancelRecheckBill: 'ยืนยันที่จะยกเลิกการตรวจสอบบิลจำนวน {0} รายการหรือไม่?',
      sameSettlementAgent: 'ตัวแทนชำระเงินของบิลต้องเหมือนกัน!',
      hasBillingGroupNo: 'ได้สร้างเลขที่ใบแจ้งหนี้แล้ว',
      noBillToBillingGroup: 'ไม่มีบิลที่สามารถทำใบแจ้งหนี้ได้',
      confirmSuccess: 'ยืนยันสำเร็จ!',
      recheckSuccess: 'ตรวจสอบสำเร็จ!',
      cancelConfirmSuccess: 'ยกเลิกการยืนยันสำเร็จ',
      cancelRecheckSuccess: 'ยกเลิกการตรวจสอบสำเร็จ!',
      reconciliationAmountNotSupport: 'จำนวนเงินที่คุณป้อนสำหรับการตรวจสอบบัญชีไม่สมเหตุสมผล!',
      overseaHasPushed: '【{0}】ใบแจ้งหนี้ได้ถูกส่งเรียบร้อยแล้ว ไม่สามารถลบได้',
      advDeleteConfirmTitle: 'ใบแจ้งหนี้การเก็บเงินและชำระเงินล่วงหน้าได้ถูกส่งไปยัง Kingdee แล้ว กรุณาตรวจสอบให้แน่ใจว่าเอกสารที่เกี่ยวข้องได้ถูกลบใน Kingdee ก่อนดำเนินการลบ'
    },
    billingGroup: {
      hasConfirmed: 'ใบแจ้งหนี้【{0}】ได้รับการยืนยันแล้ว!',
      hasReviewed: 'ใบแจ้งหนี้【{0}】ได้รับการตรวจสอบแล้ว!',
      confirmDelete: 'ยืนยันที่จะลบใบแจ้งหนี้จำนวน {0} รายการนี้หรือไม่?',
      billingNotNull: 'บิลไม่สามารถเว้นว่างได้!',
      canNotRemoveAllBills: 'ไม่สามารถลบบิลทั้งหมดได้!',
      settlementAgentNotNull: 'ตัวแทนชำระเงินของบิล【{0}】ไม่สามารถเว้นว่างได้!',
      settlementAgentAndAccountCanNotSame: 'ตัวแทนชำระเงินของบิล【{0}】ไม่ตรงกับผู้ชำระเงินในใบแจ้งหนี้ กรุณาลบบิลนี้ก่อนบันทึก!',
      validateAp: 'เมื่อประเภทการรับ-จ่ายเป็นเงินรับ จำนวนเงินรวมของบิลเงินรับต้องไม่น้อยกว่าจำนวนเงินรวมของบิลเงินจ่าย!',
      validateAr: 'เมื่อประเภทการรับ-จ่ายเป็นเงินจ่าย จำนวนเงินรวมของบิลเงินจ่ายต้องไม่น้อยกว่าจำนวนเงินรวมของบิลเงินรับ!',
      selectedBillingGroup: 'กรุณาเลือกใบแจ้งหนี้!',
      batchConfirmBillGroup: 'ยืนยันที่จะยืนยันใบแจ้งหนี้จำนวน {0} รายการพร้อมกันหรือไม่?',
      batchConfirmBill: 'อัปเดตสถานะบิลเป็นยืนยันแล้วหรือไม่?',
      noRecheckBillGroup: 'ไม่มีใบแจ้งหนี้ที่สามารถตรวจสอบได้!',
      batchRecheckBillGroup: 'ยืนยันที่จะตรวจสอบใบแจ้งหนี้จำนวน {0} รายการหรือไม่?',
      batchCancelRecheckBillGroup: 'ยืนยันที่จะยกเลิกการตรวจสอบใบแจ้งหนี้จำนวน {0} รายการหรือไม่?',
      noCancelRecheckBillGroup: 'ไม่มีใบแจ้งหนี้ที่สามารถยกเลิกการตรวจสอบได้!',
      noCancelConfirmBillGroup: 'ใบแจ้งยอดได้รับการตรวจสอบแล้ว ไม่สามารถยกเลิกการยืนยันได้!'
    }
  },
  grid: {
    resetSort: 'รีเซ็ตการเรียงลำดับ',
    restColumns: 'รีเซ็ตคอลัมน์',
    autoSizeColumns: 'ปรับคอลัมน์ทั้งหมดอัตโนมัติ',
    pinLeftAll: 'ล็อคคอลัมน์ด้านซ้ายทั้งหมด',
    subtotal: 'รวมย่อย',
    groupedSubtotal: 'นับแยกตามรายการ',
    summaryMode: 'วิธีการรวมสถิติ',
    count: 'นับ',
    sum: 'ผลรวม'
  }
}

// agGrid表格
export const i18n_ag_grid = {
  // for filter panel
  page: 'หน้า',
  more: 'เพิ่มเติม',
  to: '-',
  of: 'ถึง',
  next: 'หน้าถัดไป',
  last: 'หน้าก่อนหน้า',
  first: 'หน้าแรก',
  previous: 'previous',
  loadingOoo: 'กำลังโหลด...',

  // for set filter
  selectAll: 'เลือกทั้งหมด',
  searchOoo: 'ค้นหา...',
  blanks: 'ว่างเปล่า',

  // for number filter and text filter
  filterOoo: 'กรอง...',
  applyFilter: 'ใช้การกรอง...',

  // for number filter
  equals: 'เท่ากับ',
  lessThan: 'น้อยกว่า',
  greaterThan: 'มากกว่า',

  // for text filter
  contains: 'ประกอบด้วย',
  startsWith: 'ตั้งแต่เริ่มต้น',
  endsWith: 'สิ้นสุด',

  // the header of the default group column
  group: 'การจัดกลุ่มข้อมูล',

  // tool panel
  columns: 'ตั้งค่าคอลัมน์',
  filters: 'ตัวกรอง',
  rowGroupColumns: 'คอลัมน์กลุ่มแถว',
  rowGroupColumnsEmptyMessage: 'ลากชื่อคอลัมน์มาที่นี่เพื่อจัดกลุ่มข้อมูล (หน้าปัจจุบัน)',
  valueColumns: 'คอลัมน์ค่า',
  pivotMode: 'โหมด Pivot',
  groups: 'การจัดกลุ่มข้อมูล',
  values: 'ค่า',
  pivots: 'Pivot',
  valueColumnsEmptyMessage: 'ข้อความว่างเปล่าคอลัมน์ค่า',
  pivotColumnsEmptyMessage: 'ข้อความว่างเปล่าคอลัมน์ Pivot',
  toolPanelButton: 'ปุ่มแผงเครื่องมือ',

  // other
  noRowsToShow: 'ไม่มีผลลัพธ์การค้นหา',

  // enterprise menu
  pinColumn: 'ล็อคคอลัมน์',
  valueAggregation: 'การรวมค่า',
  autosizeThiscolumn: 'ปรับคอลัมน์อัตโนมัติ',
  autosizeAllColumns: 'ปรับคอลัมน์ทั้งหมดอัตโนมัติ',
  groupBy: 'จัดกลุ่ม',
  ungroupBy: 'ไม่จัดกลุ่ม',
  resetColumns: 'รีเซ็ต',
  expandAll: 'ขยาย',
  collapseAll: 'หด',
  toolPanel: 'แผงเครื่องมือ',
  'export': 'ส่งออก',
  csvExport: 'CSV ',
  excelExport: 'Excel ',

  // enterprise menu pinning
  pinLeft: 'ล็อกด้านซ้าย',
  pinRight: 'ล็อกด้านขวา',
  noPin: 'ไม่ล็อค <>',

  // enterprise menu aggregation and status panel
  sum: 'และ',
  min: 'น้อยที่สุด',
  max: 'มากที่สุด',
  none: 'ไม่มี',
  count: 'นับ',
  average: 'ค่าเฉลี่ย',

  // standard menu
  copy: 'คัดลอก',
  copyWithHeaders: 'คัดลอกรวมหัวตาราง',
  ctrlC: 'ctrl + C',
  paste: 'วาง',
  ctrlV: 'ctrl + V',

  // Set Filter
  selectAllSearchResults: '(เลือกผลการค้นหาทั้งหมด)',
  noMatches: 'ไม่พบผลลัพธ์ที่ตรงกัน',

  // Number Filter & Text Filter
  notEqual: 'ไม่เท่ากับ',
  empty: 'กรุณาเลือก',

  // Number Filter
  lessThanOrEqual: 'น้อยกว่าหรือเท่ากับ',
  greaterThanOrEqual: 'มากกว่าหรือเท่ากับ',
  inRange: 'ช่วง',
  inRangeStart: 'ถึง',
  inRangeEnd: 'จาก',

  // Text Filter
  notContains: 'ไม่ประกอบด้วย',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',

  // Filter Conditions
  andCondition: 'และ',
  orCondition: 'หรือ',

  // Filter Buttons
  resetFilter: 'รีเซ็ต',
  clearFilter: 'ล้าง',
  cancelFilter: 'ยกเลิก',

  // Filter Titles
  textFilter: 'ตัวกรองข้อความ',
  numberFilter: 'ตัวกรองตัวเลข',
  dateFilter: 'ตัวกรองวันที่',
  setFilter: 'ตัวกรองชุด',

  // Other
  enabled: 'เปิดใช้งาน',
  // Enterprise Menu Aggregation and Status Bar
  avg: 'เฉลี่ย',
  filteredRows: 'ที่กรองแล้ว',
  selectedRows: 'ที่เลือกแล้ว',
  totalRows: 'จำนวนแถวทั้งหมด',
  totalAndFilteredRows: 'จำนวนแถว',
  nextPage: 'หน้าถัดไป',
  lastPage: 'หน้าสุดท้าย',
  firstPage: 'หน้าแรก',
  previousPage: 'หน้าก่อนหน้า',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'มุมมองแผนภูมิและโหมดแผนภูมิ',
  pivotChart: 'มุมมองแผนภูมิ',
  chartRange: 'ช่วงแผนภูมิ',

  columnChart: 'แผนภูมิแท่ง',
  groupedColumn: 'จัดกลุ่มแล้ว',
  stackedColumn: 'ซ้อนแล้ว',
  normalizedColumn: '100% กองซ้อน',

  barChart: 'แผนภูมิแท่ง',
  groupedBar: 'จัดกลุ่มแล้ว',
  stackedBar: 'ซ้อนแล้ว',
  normalizedBar: '100% กองซ้อน',

  pieChart: 'แผนภูมิวงกลม',
  pie: 'พาย',
  doughnut: 'แผนภูมิโดนัท',

  line: 'Line',

  xyChart: 'X Y (แผนภูมิกระจาย)',
  scatter: 'กระจาย',
  bubble: 'ฟอง',

  areaChart: 'แผนภูมิพื้นที่',
  area: 'พื้นที่',
  stackedArea: 'ซ้อนแล้ว',
  normalizedArea: '100% กองซ้อน',

  histogramChart: 'ฮิสโตแกรม',

  // Charts
  pivotChartTitle: 'แผนภูมิ Pivot',
  rangeChartTitle: 'แผนภูมิช่วง',
  settings: 'การตั้งค่า',
  data: 'ข้อมูล',
  format: 'รูปแบบ',
  categories: 'หมวดหมู่',
  defaultCategory: '(ไม่มี)',
  series: 'ซีรีส์',
  xyValues: 'ค่า X Y',
  paired: 'โหมดจับคู่',
  axis: 'แกน',
  navigator: 'เนวิเกเตอร์',
  color: 'สี',
  thickness: 'ความหนา',
  xType: 'ประเภท X',
  automatic: 'อัตโนมัติ',
  category: 'หมวดหมู่',
  number: 'ตัวเลข',
  time: 'เวลา',
  xRotation: 'การหมุน X',
  yRotation: 'การหมุน Y',
  ticks: 'มาตราส่วน',
  width: 'ความกว้าง',
  height: 'ความสูง',
  length: 'ความยาว',
  padding: 'การเติม',
  spacing: 'ระยะห่าง',
  chart: 'ไอคอน',
  title: 'หัวข้อ',
  titlePlaceholder: 'หัวข้อแผนภูมิ-ดับเบิลคลิกเพื่อแก้ไข',
  background: 'พื้นหลัง',
  font: 'แบบอักษร',
  top: 'ด้านบน',
  right: 'ขวา',
  bottom: 'ด้านล่าง',
  left: 'ซ้าย',
  labels: 'ป้ายกำกับ',
  size: 'ขนาด',
  minSize: 'ขนาดขั้นต่ำ',
  maxSize: 'ขนาดสูงสุด',
  legend: 'คำอธิบาย',
  position: 'ตำแหน่ง',
  markerSize: 'ขนาดเครื่องหมาย',
  markerStroke: 'เส้นเครื่องหมาย',
  markerPadding: 'การเติมเครื่องหมาย',
  itemSpacing: 'ระยะห่างระหว่างฟิลด์',
  itemPaddingX: 'การเติมฟิลด์ X',
  itemPaddingY: 'การเติมฟิลด์ Y',
  layoutHorizontalSpacing: 'ระยะห่างแนวนอน',
  layoutVerticalSpacing: 'ระยะห่างแนวตั้ง',
  strokeWidth: 'ความกว้างเส้น',
  offset: 'ออฟเซต',
  offsets: 'ค่าออฟเซต',
  tooltips: 'แจ้งเตือน',
  callout: 'การทำเครื่องหมาย',
  markers: 'เครื่องหมาย',
  shadow: 'เงา',
  blur: 'เบลอ',
  xOffset: 'ออฟเซต X',
  yOffset: 'ออฟเซต Y',
  lineWidth: 'ความกว้างเส้น',
  normal: 'ปกติ',
  bold: 'ตัวหนา',
  italic: 'ตัวเอียง',
  boldItalic: 'ตัวหนาเอียง',
  predefined: 'กำหนดไว้ล่วงหน้า',
  fillOpacity: 'ความทึบของการเติม',
  strokeOpacity: 'ความทึบของเส้น',
  histogramBinCount: 'จำนวน Bin',
  columnGroup: 'แผนภูมิแท่ง',
  barGroup: 'แผนภูมิแท่ง',
  pieGroup: 'แผนภูมิวงกลม',
  lineGroup: 'แผนภูมิเส้น',
  scatterGroup: 'X Y (แผนภูมิกระจาย)',
  areaGroup: 'แผนภูมิพื้นที่',
  histogramGroup: 'ฮิสโตแกรม',
  groupedColumnTooltip: 'จัดกลุ่มแล้ว',
  stackedColumnTooltip: 'ซ้อนแล้ว',
  normalizedColumnTooltip: '100% กองซ้อน',
  groupedBarTooltip: 'จัดกลุ่มแล้ว',
  stackedBarTooltip: 'ซ้อนแล้ว',
  normalizedBarTooltip: '100% กองซ้อน',
  pieTooltip: 'แผนภูมิวงกลม',
  doughnutTooltip: 'แผนภูมิโดนัท',
  lineTooltip: 'แผนภูมิเส้น',
  groupedAreaTooltip: 'จัดกลุ่มแล้ว',
  stackedAreaTooltip: 'ซ้อนแล้ว',
  normalizedAreaTooltip: '100% กองซ้อน',
  scatterTooltip: 'แผนภูมิกระจาย',
  bubbleTooltip: 'แผนภูมิฟอง',
  histogramTooltip: 'ฮิสโตแกรม',
  noDataToChart: 'ไม่มีข้อมูลสำหรับการวาดแผนภูมิ',
  pivotChartRequiresPivotMode: 'แผนภูมิ Pivot ต้องเปิดใช้งานโหมด Pivot ก่อน',
  chartSettingsToolbarTooltip: 'เมนู',
  chartLinkToolbarTooltip: 'ลิงก์ไปยังแผนภูมิ',
  chartUnlinkToolbarTooltip: 'ยกเลิกการลิงก์กับแผนภูมิ',
  chartDownloadToolbarTooltip: 'ดาวน์โหลดแผนภูมิ',

  // ARIA
  ariaHidden: 'ซ่อน',
  ariaVisible: 'แสดง',
  ariaChecked: 'เลือกแล้ว',
  ariaUnchecked: 'ยังไม่ได้เลือก',
  ariaIndeterminate: 'ไม่แน่ใจ',
  ariaColumnSelectAll: 'สลับการเลือกคอลัมน์ทั้งหมด',
  ariaInputEditor: 'ตัวแก้ไขการป้อนข้อมูล',
  ariaDateFilterInput: 'กรองตามวันที่',
  ariaFilterInput: 'กรองการป้อนข้อมูล',
  ariaFilterColumnsInput: 'กรองคอลัมน์ที่ป้อน',
  ariaFilterValue: 'กรองค่า',
  ariaFilterFromValue: 'กรองจากค่า',
  ariaFilterToValue: 'กรองถึงค่า',
  ariaFilteringOperator: 'ตัวดำเนินการกรอง',
  ariaColumnToggleVisibility: 'สลับการแสดงคอลัมน์',
  ariaColumnGroupToggleVisibility: 'สลับการแสดงกลุ่มคอลัมน์',
  ariaRowSelect: 'กด Space เพื่อเลือกแถวนี้',
  ariaRowDeselect: 'กด Space เพื่อยกเลิกการเลือกแถวนี้',
  ariaRowToggleSelection: 'กด Space เพื่อสลับการเลือกแถว',
  ariaRowSelectAll: 'กด Space เพื่อสลับการเลือกแถวทั้งหมด',
  ariaSearch: 'ค้นหา',
  ariaSearchFilterValues: 'ค้นหาค่ากรอง'
}
